import { render, staticRenderFns } from "./VUSearchResultCard.vue?vue&type=template&id=2d711354&"
import script from "./VUSearchResultCard.vue?vue&type=script&lang=ts&"
export * from "./VUSearchResultCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports